import { render, staticRenderFns } from "./AgeGroup.vue?vue&type=template&id=ef43ff1e&scoped=true&lang=pug&"
import script from "./AgeGroup.vue?vue&type=script&lang=ts&"
export * from "./AgeGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AgeGroup.vue?vue&type=style&index=0&id=ef43ff1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef43ff1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arc-one/_www/millsta-ready/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef43ff1e')) {
      api.createRecord('ef43ff1e', component.options)
    } else {
      api.reload('ef43ff1e', component.options)
    }
    module.hot.accept("./AgeGroup.vue?vue&type=template&id=ef43ff1e&scoped=true&lang=pug&", function () {
      api.rerender('ef43ff1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/AgeGroup.vue"
export default component.exports